var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-warpper",class:{ isWhite: _vm.isWhite }},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.en))])])
}
var staticRenderFns = []

export { render, staticRenderFns }